import { categoriesConstants } from '../constants'

const initialState = {}

export default (state = initialState, action = {}) => {
    switch (action.type) {
        case categoriesConstants.REQUEST:
            return {
                ...state,
                pending: true,
            }
        case categoriesConstants.SUCCESS:
            return {
                ...state,
                ...action.response.data.results,
                pending: false,
            }
        case categoriesConstants.FAILURE:
            return {
                ...initialState,
                pending: false,
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/connectors/redux/reducers/categories.js